import React from 'react'
import Img from "gatsby-image";

import HeroSmall from '../components/HeroSmall'
import LocationMicroNav from '../components/LocationMicroNav'
import LocationContent from '../components/LocationContent'
import LocationRelated from '../components/LocationRelated'

class ColumbusLocation extends React.Component {
  render() {
    return (
      <div>
        <HeroSmall location="Columbus, OH" />
        <LocationMicroNav />

        <LocationContent 
          category="E-bikes" 
          title="Buckeye Breakthrough"
          story="We testified in support of HB 250 in the Ohio State Legislature's House Transportation and Public Safety Committee to update the state's e-bike law. Seven organizations supported this bill: PFB and BPSA, Rails-to-Trails Conservancy, Central Ohio Mountain Biking Organization, Five Rivers Metro Parks, Friends of Little Miami State Park, and Bike Miami Valley along with two retailers and two riders. Testifying on these bills provides us an opportunity to answer questions and educate legislators in person."
        />  
        <Img
          title="ColumbusOH"
          alt="Ebike breakthrough"
          sizes= { this.props.data.columbusImage.sizes }
        />   

        <LocationRelated 
          prevLocationName="California"
          prevLocationPath="california"
          prevLocationImgPath= { this.props.data.columbusPrevImage }
          nextLocationName="Portland, OR"
          nextLocationPath="portland"
          nextLocationImgPath= { this.props.data.columbusNextImage }
        /> 
      </div>
    )
  }
}

export default ColumbusLocation

// GraphQL query
export const ColumbusImageQuery = graphql`
  query ColumbusImageQuery {
    columbusImage: imageSharp(id: { regex: "/PFB_ColumbusOH/" }) {
      sizes(maxWidth: 1600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    columbusPrevImage: imageSharp(id: { regex: "/PFB_CALIFORNIA/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    columbusNextImage: imageSharp(id: { regex: "/PFB_PORTLAND/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/columbus.js